import Input from "@shared/components/ui-kit/form/Input/Input.web";
import useCallbackRef from "@shared/hooks/useCallbackRef/useCallbackRef";
import { useTranslation } from "@shared/utils/internationalization";
import Box from "@ui-kit/layout/Box/Box.web";
import Text from "@ui-kit/typography/Text/Text.web";
import { useEffect } from "react";
import { Controller, UseFormReturn } from "react-hook-form";

/**
 * A containing element for a name input for manual card entry
 */
function NameElement({
  form,
  onValidField,
  onInvalidField,
}: {
  form: UseFormReturn;
  onValidField?: () => void;
  onInvalidField?: () => void;
}) {
  const { t } = useTranslation("checkout");
  const onValidFieldRef = useCallbackRef(onValidField);
  const onInvalidFieldRef = useCallbackRef(onInvalidField);

  useEffect(() => {
    if (form.formState.isValid) {
      onValidFieldRef.current?.();
    } else {
      onInvalidFieldRef.current?.();
    }
  }, [form.formState.isValid]);

  const hasError = Boolean(form.formState.errors["manual-card-entry-name"]);

  return (
    <Box>
      <Box>
        <Text fontWeight={700} mb="2xs" fontSize="sm" color="fg">
          {t("Name on card")}
        </Text>
      </Box>
      <Controller
        name="manual-card-entry-name"
        control={form.control}
        rules={{
          required: t("This field is required."),
        }}
        render={({ field }) => (
          <Input
            {...field}
            h="element.3xl"
            borderRadius="sm"
            type="text"
            placeholder={t("Name on card")}
            isInvalid={hasError}
            maxLength={120}
            id="manual-card-entry-name"
            data-testid="manual-card-entry-name"
            autoComplete="cc-name"
            bg="bg"
          />
        )}
      />
      <Box>
        <Text
          color="red.600"
          noOfLines={2}
          data-testid="manual-card-entry-name-error"
        >
          {form.formState.errors["manual-card-entry-name"]?.message
            ? String(form.formState.errors["manual-card-entry-name"].message)
            : ""}
        </Text>
      </Box>
    </Box>
  );
}

export default NameElement;
